'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = require('prop-types');

var _composeWithScope = require('recompose-scope/composeWithScope');

var _composeWithScope2 = _interopRequireDefault(_composeWithScope);

var _consumeProps = require('recompose-scope/consumeProps');

var _consumeProps2 = _interopRequireDefault(_consumeProps);

var _injectProps = require('recompose-scope/injectProps');

var _injectProps2 = _interopRequireDefault(_injectProps);

var _exposeProps = require('recompose-scope/exposeProps');

var _exposeProps2 = _interopRequireDefault(_exposeProps);

var _defaultProps = require('recompose/defaultProps');

var _defaultProps2 = _interopRequireDefault(_defaultProps);

var _withProps = require('recompose/withProps');

var _withProps2 = _interopRequireDefault(_withProps);

var _withHandlers = require('recompose/withHandlers');

var _withHandlers2 = _interopRequireDefault(_withHandlers);

var _getContext = require('recompose/getContext');

var _getContext2 = _interopRequireDefault(_getContext);

var _mixSpliter = require('coact-utils/mixSpliter');

var _mixSpliter2 = _interopRequireDefault(_mixSpliter);

var _setWrappedDisplayName = require('coact-utils/setWrappedDisplayName');

var _setWrappedDisplayName2 = _interopRequireDefault(_setWrappedDisplayName);

var _objectEditorEnhancer = require('../objectEditorEnhancer');

var _objectEditorEnhancer2 = _interopRequireDefault(_objectEditorEnhancer);

var _appendEmptyItem = require('./appendEmptyItem');

var _appendEmptyItem2 = _interopRequireDefault(_appendEmptyItem);

var _memoize = require('lodash/memoize');

var _memoize2 = _interopRequireDefault(_memoize);

var _ramda = require('ramda');

var _createBySchema = require('../../../utils/creation/createBySchema');

var _createBySchema2 = _interopRequireDefault(_createBySchema);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function removeByIndex(originArr, index) {
  var arr = [].concat(_toConsumableArray(originArr));
  arr.splice(index, 1);
  return arr;
}
function insertByIndex(originArr, index, item) {
  var arr = [].concat(_toConsumableArray(originArr));
  arr.splice(index, 0, item);
  return arr;
}
function moveByIndex(originArr, index, to) {
  var item = originArr[index];
  var arr = [].concat(_toConsumableArray(originArr));
  arr.splice(index, 1);
  var insert = index < to ? to - 1 : to;
  arr.splice(insert, 0, item);
  return arr;
}

var getInsertIndex = function getInsertIndex(_ref) {
  var index = _ref.index,
      items = _ref.items,
      isLastEmpty = _ref.isLastEmpty,
      to = _ref.to,
      isMove = _ref.isMove;

  if (to === 'last') return isLastEmpty ? items.length - 1 : items.length;
  if (to === 'next') return isMove ? index + 2 : index + 1;
  if (to === 'prev') return isMove ? index - 1 : index;
  if (to === 'first') return 0;
  return to;
};
var isReachLimit = function isReachLimit(_ref2) {
  var isLastEmpty = _ref2.isLastEmpty,
      value = _ref2.value,
      limit = _ref2.limit;

  var length = isLastEmpty ? value.length - 1 : value.length;
  var result = length >= limit;
  if (result) {
    // eslint-disable-next-line no-alert
    window.alert('項目數量已達上限');
  }
  return result;
};
var removeEmptyIfNeed = function removeEmptyIfNeed(_ref3) {
  var value = _ref3.value,
      limit = _ref3.limit,
      isLastEmpty = _ref3.isLastEmpty;

  if (!isLastEmpty) return value;
  if (value.length <= limit) return value;
  return removeByIndex(value, value.length - 1);
};

var removeItem = function removeItem(_ref4) {
  var onChange = _ref4.onChange;
  return function (_ref5) {
    var index = _ref5.index;
    return new Promise(function (resolve) {
      return onChange(function (items) {
        return removeByIndex(items, index);
      }, resolve);
    });
  };
};
var copyItem = function copyItem(props) {
  return function () {
    var _ref6 = _asyncToGenerator(regeneratorRuntime.mark(function _callee(_ref7) {
      var index = _ref7.index,
          _ref7$to = _ref7.to,
          to = _ref7$to === undefined ? 'last' : _ref7$to,
          _ref7$copier = _ref7.copier,
          copier = _ref7$copier === undefined ? function (item) {
        return item;
      } : _ref7$copier;
      var onChange, createEmpty, isLastEmpty, emptyItem;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              onChange = props.onChange, createEmpty = props.createEmpty, isLastEmpty = props.isLastEmpty;

              if (!isReachLimit(props)) {
                _context.next = 3;
                break;
              }

              return _context.abrupt('return', true);

            case 3:
              _context.next = 5;
              return createEmpty();

            case 5:
              emptyItem = _context.sent;
              return _context.abrupt('return', new Promise(function (resolve) {
                return onChange(function (items) {
                  if (isReachLimit(_extends({}, props, { value: items }))) return items;

                  var copy = _extends({}, emptyItem, copier(items[index]), { _id: emptyItem._id });
                  var insertIndex = getInsertIndex({ index: index, items: items, isLastEmpty: isLastEmpty, to: to });
                  var insertedItems = insertByIndex(items, insertIndex, copy);

                  return removeEmptyIfNeed(_extends({}, props, { value: insertedItems }));
                }, resolve);
              }));

            case 7:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, undefined);
    }));

    return function (_x) {
      return _ref6.apply(this, arguments);
    };
  }();
};
var insertItem = function insertItem(props) {
  return function () {
    var _ref8 = _asyncToGenerator(regeneratorRuntime.mark(function _callee2(_ref9) {
      var index = _ref9.index,
          _ref9$to = _ref9.to,
          to = _ref9$to === undefined ? 'next' : _ref9$to;
      var onChange, createEmpty, isLastEmpty, emptyItem;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              onChange = props.onChange, createEmpty = props.createEmpty, isLastEmpty = props.isLastEmpty;

              if (!isReachLimit(props)) {
                _context2.next = 3;
                break;
              }

              return _context2.abrupt('return', true);

            case 3:
              _context2.next = 5;
              return createEmpty();

            case 5:
              emptyItem = _context2.sent;
              return _context2.abrupt('return', new Promise(function (resolve) {
                return onChange(function (items) {
                  if (isReachLimit(_extends({}, props, { value: items }))) return items;

                  var insertIndex = getInsertIndex({ index: index, items: items, isLastEmpty: isLastEmpty, to: to });
                  var insertedItems = insertByIndex(items, insertIndex, emptyItem);

                  return removeEmptyIfNeed(_extends({}, props, { value: insertedItems }));
                }, resolve);
              }));

            case 7:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, undefined);
    }));

    return function (_x2) {
      return _ref8.apply(this, arguments);
    };
  }();
};
var moveItem = function moveItem(_ref10) {
  var onChange = _ref10.onChange,
      isLastEmpty = _ref10.isLastEmpty;
  return function () {
    var _ref11 = _asyncToGenerator(regeneratorRuntime.mark(function _callee3(_ref12) {
      var index = _ref12.index,
          _ref12$to = _ref12.to,
          to = _ref12$to === undefined ? 'prev' : _ref12$to;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt('return', new Promise(function (resolve) {
                return onChange(function (items) {
                  var insertIndex = getInsertIndex({ index: index, items: items, isLastEmpty: isLastEmpty, to: to, isMove: true });
                  var validLength = isLastEmpty ? items.length - 1 : items.length;
                  if (insertIndex < 0) return items;
                  if (insertIndex > validLength) return items;
                  return moveByIndex(items, index, insertIndex);
                }, resolve);
              }));

            case 1:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, undefined);
    }));

    return function (_x3) {
      return _ref11.apply(this, arguments);
    };
  }();
};

var memoizeSplitAction = function memoizeSplitAction(split) {
  _memoize2.default.Cache = WeakMap;
  // ................................memoize(key => split(action)(key)))
  var memoized = (0, _memoize2.default)(function (action) {
    return (0, _memoize2.default)(split(action));
  });
  _memoize2.default.Cache = undefined;
  return memoized;
};
var splitAction = memoizeSplitAction( // memoize the first two currying arg
function (action) {
  return function (index) {
    return function (spec) {
      return action(_extends({ index: index }, spec));
    };
  };
});

function waitItemAction(promise) {
  return function () {
    return promise;
  };
}
var finishBeforeSave = function finishBeforeSave(action) {
  return function (props) {
    return function () {
      var _ref13 = _asyncToGenerator(regeneratorRuntime.mark(function _callee4() {
        var emitter,
            promise,
            listener,
            _args4 = arguments;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                emitter = props.emitter;
                promise = action(props).apply(undefined, _args4);
                listener = waitItemAction(promise);

                emitter.addListener('endEditing', listener);
                return _context4.abrupt('return', promise.then(function (value) {
                  emitter.removeListener('endEditing', listener);
                  return value;
                }));

              case 5:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, undefined);
      }));

      return function () {
        return _ref13.apply(this, arguments);
      };
    }();
  };
};

var enhancer = (0, _composeWithScope2.default)((0, _injectProps2.default)({
  value: _propTypes.array,
  schema: _propTypes.object
}), (0, _consumeProps2.default)({
  onChange: _propTypes.func.isRequired,

  validator: _propTypes.func,
  computer: _propTypes.func,

  limit: _propTypes.number,
  stopAppend: _propTypes.bool,

  copier: _propTypes.func
}), (0, _getContext2.default)({
  server: _propTypes.object,
  emitter: _propTypes.object
}), (0, _defaultProps2.default)({
  limit: 256
}), (0, _withProps2.default)(function (_ref14) {
  var length = _ref14.value.length,
      limit = _ref14.limit,
      schema = _ref14.schema,
      server = _ref14.server;
  return {
    isFull: length >= limit,
    createEmpty: function createEmpty() {
      return (0, _createBySchema2.default)(schema.contents[0], { server: server });
    }
  };
}), _objectEditorEnhancer2.default, _appendEmptyItem2.default, (0, _withHandlers2.default)((0, _ramda.map)(finishBeforeSave, {
  copyItem: copyItem,
  removeItem: removeItem,
  insertItem: insertItem,
  moveItem: moveItem
})),

// eslint-disable-next-line no-shadow
(0, _mixSpliter2.default)(function (_ref15) {
  var copyItem = _ref15.copyItem,
      removeItem = _ref15.removeItem,
      insertItem = _ref15.insertItem,
      moveItem = _ref15.moveItem;
  return function (index) {
    return {
      remove: splitAction(removeItem)(index),
      copy: splitAction(copyItem)(index),
      insert: splitAction(insertItem)(index),
      move: splitAction(moveItem)(index)
    };
  };
}), (0, _exposeProps2.default)(['onChange', 'spliter', 'copyItem', 'removeItem', 'insertItem', 'moveItem']));

exports.default = (0, _setWrappedDisplayName2.default)(enhancer, 'editLineItems');


//////////////////
// WEBPACK FOOTER
// ./~/coact/components/DocEditor/editLineItems/index.js
// module id = 1833
// module chunks = 0